export default "__VITE_ASSET__dc53be41__"